<script setup lang="ts">
import { useAcquisitionStoreServer } from '@/api';
import type Uppy from '@uppy/core';
import { UppyContextProvider } from '@uppy/vue';
import { ToastProvider, TooltipProvider } from 'reka-ui';
import { onBeforeMount } from 'vue';
import { RouterView } from 'vue-router';
import NotificationLayout from '../layout/NotificationLayout.vue';
import { useLoading } from '../stores/loadingStore';
import { useCompanionUppy } from './composables/useCompanionUppy';
import { useCompanionAuth } from './stores/companionAuthStore';

const { VITE_API_URL = '/api' } = import.meta.env;

useAcquisitionStoreServer(VITE_API_URL);

const { busy } = useLoading();
const { bootstrap } = useCompanionAuth();
const { addResponseInterceptor } = useAcquisitionStoreServer();
const { uppy } = useCompanionUppy({ registerNotifications: true });

onBeforeMount(() => {
  bootstrap();

  addResponseInterceptor(async (url, request, response) => {
    if (response.status === 401) {
      // Handle unauthorized - companion session expired or invalid
    } else if (response.status === 403) {
      // Handle forbidden
    } else if (response.status > 404) {
      // Handle server errors
    }
    return response;
  });
});
</script>

<template>
  <ToastProvider :duration="3000">
    <TooltipProvider>
      <UppyContextProvider :uppy="uppy as unknown as Uppy">
        <!-- The companion has no navbar to hang it off, so the shared loading
             state gets its own bar at the top of the viewport. -->
        <progress
          v-show="busy"
          class="progress progress-primary fixed top-0 left-0 z-50 h-1 w-full rounded-none"
        />
        <RouterView />
        <NotificationLayout />
      </UppyContextProvider>
    </TooltipProvider>
  </ToastProvider>
</template>
